<div class="tags-container" *ngIf="tags">
  <div class="tag" *ngFor="
      let tag of tags ?? '' | split : ','
    ">
    <span>{{ tag.trim() | tags }}</span>
  </div>
</div>